var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComparisonTablePrintScanCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 59,
    viewBox: "0 0 47 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8458 15.25H44.0493L43.2001 14.3972L32.6668 3.81904L31.8125 2.9611V4.17184V13.2707C31.8125 14.3601 32.6956 15.25 33.7856 15.25H42.8458ZM29.875 2.95V2.45H29.375H5.87464C3.97697 2.45 2.4375 3.99908 2.4375 5.89964V53.1004C2.4375 55.0009 3.97697 56.55 5.87464 56.55H41.1254C43.023 56.55 44.5625 55.0009 44.5625 53.1004V17.7V17.2H44.0625H33.7856C31.6311 17.2 29.875 15.4395 29.875 13.2707V2.95ZM33.6789 2.08078L44.925 13.3748C45.9333 14.3873 46.5 15.7609 46.5 17.1937V53.1004C46.5 56.0845 44.0917 58.5 41.1254 58.5H5.87464C2.90834 58.5 0.5 56.0845 0.5 53.1004V5.89964C0.5 2.91553 2.90834 0.5 5.87464 0.5H29.8792C31.3039 0.5 32.6707 1.06835 33.6789 2.08078Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonTablePrintScanCopyIcon);
export default __webpack_public_path__ + "static/media/comparison_table_print_scan_copy_icon.2a56563d7a7819e27fe5f268159187b7.svg";
export { ForwardRef as ReactComponent };